module.exports = __webpack_public_path__ + "img/9788954430098.f8aee7e6.jpg";